module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAXCAMAAAAMT46wAAAAbFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8+T+BWAAAAI3RSTlMAEw7WHfz55tzKIwnh0MCOcm1oWEwY6riphoF8dmxkX1I1KojYU6oAAABsSURBVBjTXc9JFoJAFENRqQKpUlBAsZfu7X+PcJj8QGZ3kpwcdkny11noHjzVU85FfVrs1AVRnQZiovaU6tbjW50v8ak6EtQuUEh/A5XpD7Wpgsb0g870JetNH7Kb6Y3qynHY6C5nV1nqUTADRJkG0qaZResAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow.png
// module id = qNF3
// module chunks = 1